import axios from 'axios';
import moment from 'moment';

export const server = process.env.REACT_APP_MODE;
const apiUrl = getBaseUrl(server);
const loadDelay = 0;

function getBaseUrl(s) {
  switch (s) {
    case 'local':
      return 'http://localhost:8080/api';
    case 'staging':
      return 'https://staging.api.ctrlv.ca/api';
    case 'production':
      return 'https://api.ctrlv.ca/api';
    default:
      console.error('No Server Specified!');
      throw new Error('You are not doing this right.');
  }
}

export function getTimeslotsForDay(day, location_id) {
  const endpointUrl = '/booking/getTimeslotsForWeb';
  const queries = '?start=' + moment(day).add(12, 'hour').format('YYYY-MM-DDTHH:mm')
    + '&end=' + moment(day).add(36, 'hour').format('YYYY-MM-DDTHH:mm')
    + '&location=' + location_id;
  // console.log(apiUrl + endpointUrl + queries);

  return new Promise((resolve, reject) => {
    axios.get(apiUrl + endpointUrl + queries)
      .then(response => {
        const res = response.data;
        if (res.success === false) reject(res.error);
        else {
          setTimeout(() => {
            resolve(res.result);
          }, loadDelay);
        }
      }).catch(error => {
        reject(error);
      });
  });
}

export function getMoveBooking(booking_code, email, phone) {
  const endpointUrl = '/booking/getMoveBooking';
  const formattedPhone = phone.replace(/[ ()-]/g, '');

  return new Promise((resolve, reject) => {
    axios.post(apiUrl + endpointUrl, { booking_code, email, phone: formattedPhone })
      .then(response => {
        const res = response.data;
        if (res.success === false) reject(res.error);
        else {
          // check if booking has too many modifications
          if (res.result.count >= 3) reject('This booking can no longer be moved using our online system. Please contact ' + res.result.facility_email + ' for further assistance.');
          if (res.result.contains_party_room === true) reject('This booking can not be moved using our online system. Please contact ' + res.result.facility_email + ' for further assistance.');

          // check if booking is in the past
          if (moment(res.result.booking_time).tz(res.result.time_zone).valueOf() <= moment().tz(res.result.time_zone).valueOf()) reject('Booking is in the past.');

          // check if booking is less than a day later
          if (moment(res.result.booking_time).tz(res.result.time_zone).valueOf() <= moment().add(1, 'day').tz(res.result.time_zone).valueOf()) reject('Booking is within 24 hours, please contact ' + res.result.facility_email + ' for further assistance.');

          setTimeout(() => {
            resolve(res.result);
          }, loadDelay);
        }
      }).catch(error => {
        reject(error);
      });
  });
}

export function webMoveBooking(booking_code, timeslot_map) {
  const endpointUrl = '/booking/webMoveBooking';
  // console.log('{ booking_code, created_by: -2016, timeslot_map }', { booking_code, created_by: -2016, timeslot_map });

  return new Promise((resolve, reject) => {
    axios.post(apiUrl + endpointUrl, { booking_code, created_by: -2016, timeslot_map })
      .then(response => {
        const res = response.data;
        if (res.success === false || res.result === undefined) reject(res.error);
        else {
          setTimeout(() => {
            resolve(res.result);
          }, loadDelay);
        }
      }).catch(error => {
        reject(error);
      });
  });
}
